import angular from 'angular';
import TitleBarComponent from './title-bar.component';

const TitleBarModule = angular
    .module('control-room.commons.layout.components.title-bar', [])
    .component('crTitleBar', TitleBarComponent);

export default TitleBarModule;
